module.exports = __webpack_public_path__ + "img/c25.270d3cbc.png";